import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { formatNumber } from "../../../services/mappings";

const styles = StyleSheet.create({
  mainRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    border: "1pt solid #000",
    fontWeight: "bold",
    width: "46%",
    backgroundColor: "#f0f0f0",
  },
  titleCell: {
    width: "80%",
  },
  valueCell: {
    width: "20%",
    fontSize: 8,
    textAlign: "right",
  },
});

function TotalRow({ title, value }) {
  return (
    <>
      <View style={styles.mainRow}>
        <View style={styles.titleCell}>
          <Text>{title}</Text>
        </View>
        <View style={styles.valueCell}>
          <Text>{formatNumber(value, 0, 0)}</Text>
        </View>
      </View>
    </>
  );
}

export default TotalRow;
